import React from 'react';
import { DtpFooter } from 'dtp-react-components';
import PropTypes from 'prop-types';

const recuperarVersaoAtual = () => {
  const { versaoAtual } = window.comprevConfigVersao;
  return versaoAtual;
};

const footer = props => (
  <DtpFooter >
    <div className="left text-aviso-padding">
      {props.mensagem}
    </div>
    <div className="right text-versao-padding">
      versão {recuperarVersaoAtual()}
    </div>
  </DtpFooter>
);

footer.propTypes = {
  mensagem: PropTypes.string.isRequired,
};

export default footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx